export const firebaseConfig = {
  apiKey: "AIzaSyD8CktSRQ3naAe-J5D01ISAQ8dy14qqU1U",
  authDomain: "viridian-app.firebaseapp.com",
  databaseURL: "https://viridian-app-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "viridian-app",
  storageBucket: "viridian-app.appspot.com",
  messagingSenderId: "537244379233",
  appId: "1:537244379233:web:6aa447d11ef984945e6220"
}

export const allowedUsers = [ "ilyazonov@gmail.com", "nitzan@zi-shop.de", "francemaz98@gmail.com", "lexer@zi-shop.de" ]